import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {CompanyDetailsEntityModel} from "../company-details-entity.model";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "company-details-edit-page",
    templateUrl: "./company-details-edit-page.component.html",
    providers: [provideEntityModel(CompanyDetailsEntityModel)]
})
export class CompanyDetailsEditPageComponent extends AbstractEditPage {

    constructor(public model: CompanyDetailsEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
